import { auditCollectorPiletModals } from '@sharefiledev/audit-collector-pilet-sdk';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { AsyncCreateActivityReport } from './chunkLoading';

export function addBlocks(piral: PiletApi) {
	/** Extension name MUST match what is in the UI Manifest {@see ../development/uiManifest.json} */
	piral.registerExtension(
		auditCollectorPiletModals.createActivityReportBlock,
		({ params }) => <AsyncCreateActivityReport {...params} piral={piral} />
	);
}
